import React from 'react';
import { Box, Typography } from '@mui/material';
import ScheduleCard from '../ScheduleCard';
import { useScheduleStyles } from './styles';
import dayjs from 'dayjs';
import { useBookingsContext } from '../../../contexts/BookingsContext';
import { IBooking } from '@homeporter/types';

interface IBookingCard {
  booking_date: string;
  bookings: IBooking[];
}

const Schedule = () => {
  const scheduleStyles = useScheduleStyles();
  const { groupedBookings, bookingListType }: any = useBookingsContext();

  return (
    <Box sx={scheduleStyles.parent}>
      {groupedBookings?.map(
        ({ booking_date, bookings }: IBookingCard, index: number) => {
          return (
            <Box marginBottom={'1.875rem'} key={index}>
              <Box
                display="flex"
                marginBottom="0.8125rem"
                alignItems={'flex-end'}>
                <Typography sx={scheduleStyles.date}>
                  {dayjs(booking_date).format('DD')}{' '}
                  <span style={scheduleStyles.dateSpan}>
                    {dayjs(booking_date).format('MMMM, YYYY')}
                  </span>
                </Typography>
              </Box>

              {bookings.map((booking: any, index: number) => {
                return (
                  <ScheduleCard
                    tab={bookingListType === 'archived' ? 'archived' : ''}
                    booking={booking}
                    key={index}
                  />
                );
              })}
            </Box>
          );
        },
      )}
    </Box>
  );
};

export default Schedule;
